import { createContext, useContext, useState, useEffect } from "react";

const STR = {
  it: {
    nav: { menu: "Menu", gallery: "Galleria", philosophy: "Filosofia", book: "Prenota un tavolo", admin: "Area riservata", openMenu: "Apri menu", closeMenu: "Chiudi menu", google: "Accedi con Google", logout: "Esci", hi: "Ciao" },
    hero: {
      overline: "Pizzeria artigianale",
      line1: "L'arte della",
      line2: "pizza romana",
      tagline: "Semplice, autentica, indimenticabile.",
      sub: "Impasto a lunga lievitazione e ingredienti del territorio. Una pizzeria come un atelier, nel cuore di Roma.",
      cta1: "Prenota un tavolo",
      cta2: "Scopri il menu",
      scroll: "Scorri",
    },
    marquee: ["Lievitazione 48 ore", "Ingredienti del territorio", "Funghetto Roma", "La pizza romana"],
    manifesto: {
      overline: "01 — Manifesto",
      title: "Tre regole e un'unica ossessione",
      chapters: [
        { n: "01", t: "La pizza romana", s: "Croccante, sottile, fatta come piace a Roma.", d: "Una pizza che parte dalla tradizione romana e guarda al presente. Impasto leggero, cottura precisa e ingredienti scelti per creare una pizza semplice da capire, difficile da dimenticare." },
        { n: "02", t: "Il gusto", s: "Pochi ingredienti, scelti bene.", d: "La qualità non ha bisogno di essere complicata. Selezioniamo materie prime italiane e le abbiniamo con equilibrio, per lasciare spazio al sapore e rendere ogni morso riconoscibile." },
        { n: "03", t: "L'esperienza", s: "Funghetto è Roma, ma con il suo stile.", d: "Pizza, drink e convivialità in un ambiente contemporaneo e informale. Un posto dove venire per una pizza, fermarsi per un cocktail e tornare perché ci si è trovati bene." },
      ],
    },
    menu: {
      overline: "02 — Il menu",
      title: "La carta",
      cats: { all: "Tutti", fritti: "Fritti e sfizi", focacce: "Focacce", signature: "Signature", classiche: "Classiche", rosse: "Rosse d'autore", cocktail: "Cocktail", dolci: "Dolci" },
      note: "I numeri tra parentesi indicano gli allergeni (Reg. UE 1169/2011) · Segnalateci allergie e intolleranze, la cucina è a vostra disposizione.",
      soldout: "Esaurito",
      loading: "Caricamento del menu…",
    },
    gallery: { overline: "— La galleria", title: "Scatti dal banco" },
    reservation: {
      overline: "03 — Prenotazioni",
      title: "Il tuo tavolo ti aspetta",
      sub: "Compila il modulo: la richiesta arriva direttamente in sala e ricevi conferma appena possibile.",
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono",
      date: "Data",
      time: "Orario",
      guests: "Ospiti",
      note: "Note (opzionale)",
      notePh: "Allergie, seggiolone, occasioni speciali…",
      submit: "Invia richiesta",
      sending: "Invio in corso…",
      successTitle: "Richiesta inviata",
      successText: "Grazie {name}! La tua richiesta per {guests} ospiti il {date} alle {time} è stata ricevuta. Ti confermeremo il tavolo al più presto.",
      again: "Invia un'altra richiesta",
      error: "Qualcosa è andato storto. Riprova o chiamaci.",
      guestsUnit: { one: "ospite", many: "ospiti" },
    },
    footer: {
      contacts: "Contatti",
      hours: "Orari",
      everyday: "Tutti i giorni 17:00 — 23:00",
      whatsapp: "Scrivici su WhatsApp",
      address: "Via Urbano II 32, 00167 Roma",
      rights: "Tutti i diritti riservati.",
    },
  },
  en: {
    nav: { menu: "Menu", gallery: "Gallery", philosophy: "Philosophy", book: "Book a table", admin: "Staff area", openMenu: "Open menu", closeMenu: "Close menu", google: "Sign in with Google", logout: "Sign out", hi: "Hi" },
    hero: {
      overline: "Artisan pizzeria",
      line1: "The art of",
      line2: "Roman pizza",
      tagline: "Simple, authentic, unforgettable.",
      sub: "Slow-fermented dough and local ingredients. A pizzeria like an atelier, in the heart of Rome.",
      cta1: "Book a table",
      cta2: "Explore the menu",
      scroll: "Scroll",
    },
    marquee: ["48-hour fermentation", "Local ingredients", "Funghetto Roma", "Roman pizza"],
    manifesto: {
      overline: "01 — Manifesto",
      title: "Three rules and one obsession",
      chapters: [
        { n: "01", t: "The Roman pizza", s: "Crispy, thin, made the way Rome likes it.", d: "A pizza rooted in Roman tradition, looking to the present. Light dough, precise baking and chosen ingredients, for a pizza that is simple to understand and hard to forget." },
        { n: "02", t: "Taste", s: "Few ingredients, well chosen.", d: "Quality doesn't need to be complicated. We select Italian raw ingredients and pair them with balance, leaving room for flavour and making every bite recognisable." },
        { n: "03", t: "The experience", s: "Funghetto is Rome, with its own style.", d: "Pizza, drinks and conviviality in a contemporary, informal setting. A place to come for a pizza, stay for a cocktail and return because you felt at home." },
      ],
    },
    menu: {
      overline: "02 — The menu",
      title: "La carta",
      cats: { all: "All", fritti: "Fried bites", focacce: "Focacce", signature: "Signature", classiche: "Classics", rosse: "Red specials", cocktail: "Cocktails", dolci: "Desserts" },
      note: "Numbers in brackets refer to allergens (EU Reg. 1169/2011) · Tell us about any allergies — our kitchen is at your service.",
      soldout: "Sold out",
      loading: "Loading the menu…",
    },
    gallery: { overline: "— The gallery", title: "Shots from the counter" },
    reservation: {
      overline: "03 — Reservations",
      title: "Your table awaits",
      sub: "Fill in the form: your request goes straight to the dining room and we confirm as soon as possible.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      date: "Date",
      time: "Time",
      guests: "Guests",
      note: "Notes (optional)",
      notePh: "Allergies, high chair, special occasions…",
      submit: "Send request",
      sending: "Sending…",
      successTitle: "Request sent",
      successText: "Thank you {name}! Your request for {guests} guests on {date} at {time} has been received. We will confirm your table shortly.",
      again: "Send another request",
      error: "Something went wrong. Please try again or call us.",
      guestsUnit: { one: "guest", many: "guests" },
    },
    footer: {
      contacts: "Contacts",
      hours: "Hours",
      everyday: "Open every day 17:00 — 23:00",
      whatsapp: "Message us on WhatsApp",
      address: "Via Urbano II 32, 00167 Rome",
      rights: "All rights reserved.",
    },
  },
};

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("funghetto-lang") || "it");
  useEffect(() => {
    localStorage.setItem("funghetto-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return (
    <LangCtx.Provider value={{ lang, setLang, t: STR[lang] }}>
      {children}
    </LangCtx.Provider>
  );
}

export const useLang = () => useContext(LangCtx);
